import {
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Tooltip,
  SxProps,
  Theme,
  Box,
} from '@mui/material';
import React from 'react';
import type { TranslatedString } from 'intl';
import ForbiddenTooltip from 'components/general/ForbiddenTooltip/ForbiddenTooltip';
import {
  disabledIconButtonSx,
  disabledMobileMenuItemSx,
  iconButtonSx,
  mobileMenuItemSx,
} from './styles';

interface ActionButtonProps {
  isMobile: boolean;
  onClick: () => void;
  onMouseDown?: () => void;
  disabled?: boolean;
  tooltipTitle: string | TranslatedString;
  label: string | TranslatedString;
  icon: React.ReactNode;
  additionalIconButtonSx?: SxProps<Theme>;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  isMobile,
  onClick,
  onMouseDown,
  disabled = false,
  tooltipTitle,
  label,
  icon,
  additionalIconButtonSx,
}) => {
  if (isMobile) {
    const menuItem = (
      <MenuItem
        onMouseDown={disabled ? undefined : onMouseDown}
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
        sx={disabled ? disabledMobileMenuItemSx : mobileMenuItemSx}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
    );

    if (disabled) {
      return (
        <ForbiddenTooltip
          placement='left'
          visibleWhen={true}
          title={tooltipTitle}
        >
          {menuItem}
        </ForbiddenTooltip>
      );
    }

    return menuItem;
  }

  const baseSx = disabled ? disabledIconButtonSx : iconButtonSx;

  const iconButton = (
    <IconButton
      onMouseDown={disabled ? undefined : onMouseDown}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      sx={
        additionalIconButtonSx
          ? ({ ...baseSx, ...additionalIconButtonSx } as SxProps<Theme>)
          : baseSx
      }
    >
      {icon}
    </IconButton>
  );

  if (disabled) {
    return (
      <ForbiddenTooltip visibleWhen={true} title={tooltipTitle}>
        <span>{iconButton}</span>
      </ForbiddenTooltip>
    );
  }

  return <Tooltip title={tooltipTitle}>{iconButton}</Tooltip>;
};
